export const SIZE_INFO = {
  standard: { label: "Piccola", pct: 0, desc: "Composizione essenziale" },
  large: { label: "Media", pct: 20, desc: "Come in foto", photo: true },
  extra_large: { label: "Grande", pct: 40, desc: "Composizione ricca" },
};

export const SIZES = Object.keys(SIZE_INFO);
export const DEFAULT_SIZE = "large";
export const PHOTO_SIZE = "large";
export const PRICE_NOTE = "Il prezzo \"da\" si riferisce alla misura Piccola; la foto mostra la misura Media.";

export const sizeLabel = (size) => SIZE_INFO[size]?.label || "Piccola";

export const sizePrice = (product, size = "standard") =>
  product.size_prices?.[size] ?? (product.display_price ?? product.price) * (1 + (SIZE_INFO[size]?.pct || 0) / 100);

export const defaultSize = (sizes) => (!sizes || sizes.includes(DEFAULT_SIZE) ? DEFAULT_SIZE : sizes[0] || "standard");
